//////////////////////////////

module.exports = (type) => {
    var schema = {
        label: {
            type: type.STRING(1024),
            allowNull: false,
            set( value ) {
                var label = value.toLowerCase();
                this.setDataValue('label', label);
            },
        },
        company_id: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'companies',
                key         : 'id',
                constraints : true,
                store_name  : 'company',
            }
        },
        enabled: {
            type: type.BOOLEAN,
            allowNull: false,
            defaultValue: true,
        },
        created: {
            type: type.DATE,
            allowNull: false,
            defaultValue: type.NOW,
        },
        config: {
            type: type.JSON,
            allowNull: false,
            defaultValue: { case_insensitive: true },
        },
        case_insensitive: {
            type: type.VIRTUAL,
            allowNull: false,
            boolean: true,
            defaultValue: true,
        },
        created_by: {
            type: type.INTEGER,
            allowNull: false,
            references: {
                model       : 'users',
                key         : 'id',
                constraints : true,
                store_name  : 'user',
            }
        },
        id: {
          type: type.INTEGER,
          primaryKey: true,
          autoIncrement: true
        },
    };

    return schema;
}
